import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { SharedService } from 'src/app/shared.service';
import { TranslateService } from '@ngx-translate/core';
import {Router} from "@angular/router";
import { DashboardComponent } from '../dashboard.component';
import { MatRadioChange } from '@angular/material/radio';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.css']
})
export class UserComponent implements OnInit {

  constructor(public parent: DashboardComponent, private service:SharedService, private cookieService: CookieService, public translate: TranslateService, private router:Router) {

    translate.addLangs(['en', 'ro']);
    translate.setDefaultLang('en');

    const browserLang = this.parent.getLanguage();
    translate.use(browserLang.match(/en|ro/) ? browserLang : 'en');

   }

  Password:string;
  NewPassword:string;
  ConfirmNewPassword:string;

  hide:boolean;
  hideNewPass:boolean;
  hideConfirmNewPass:boolean;

  ngOnInit(): void {
   this.hide = true;
   this.hideNewPass = true;
   this.hideConfirmNewPass = true;
   this.GetUserAppAccess();
  }
  
  ResetToken(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage()
    };

    this.parent.loading = true;

    this.service.ResetToken(request).subscribe(response => {
   
      if(response["Status"] != 1){
      
      }
      else if(response["Status"] == 1){
        this.parent.User.Token = response["Token"];
        localStorage.setItem('User', JSON.stringify(this.parent.User));
      }
   
      this.parent.loading = false;
    });
  }

  UpdateUser(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage()
    };

    this.parent.loading = true;

    this.service.UpdateUser(request).subscribe(response => {
   
      if(response["Status"] != 1){
      
      }
      else if(response["Status"] == 1){
        localStorage.setItem('User', JSON.stringify(this.parent.User));
      }
   
      this.parent.loading = false;
    });
  }

  ChangeUserPassword(){

    var request = {
      User:this.parent.User,
      Password:this.Password,
      NewPassword:this.NewPassword,
      ConfirmNewPassword:this.ConfirmNewPassword,
      Language:this.parent.getLanguage()
    };

    this.parent.loading = true;

    this.service.ChangeUserPassword(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.parent.LogOff();
      }
   
      this.parent.loading = false;
    });
  }

  RequestUserCompanyAccess(company:any){

    var request = {
      User:this.parent.User,
      CompanyID:company.ID,
      Language:this.parent.getLanguage()
    };

    this.parent.loading = true;

    this.service.RequestUserCompanyAccess(request).subscribe(response => {
   
      if(response["Status"] != 1){
      
      }
      else if(response["Status"] == 1){

        this.parent.User.Rights.AssignedCompanies.forEach(element => {
          
          if(element.ID == response["RequestedAccess"].CompanyID) {
            element.RequestedAccess = response["RequestedAccess"];
          }
        });

        localStorage.setItem('User', JSON.stringify(this.parent.User));
      }
   
      this.parent.loading = false;
    });
  }

  RadioChangeLanguage($event: MatRadioChange){
    this.parent.User.Settings.Language = $event.value;
    this.AddUpdateUserSettings();
  }

  ChangeLanguage(lang:any){
    this.parent.User.Settings.Language = lang;
    this.AddUpdateUserSettings();
  }

  AddUpdateUserSettings(){

    var request = {
      User:this.parent.User,
      Settings:this.parent.User.Settings,
      Language:this.parent.getLanguage()
    };

    this.parent.loading = true;

    this.service.AddUpdateUserSettings(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        localStorage.setItem('User', JSON.stringify(this.parent.User));
        this.parent.setLanguage(this.parent.User.Settings.Language.Name.toLowerCase());
        this.parent.translate.use(this.parent.User.Settings.Language.Name.toLowerCase());

        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
   
      this.parent.loading = false;
    });
  }

  compareFn(c1: any, c2: any): boolean {
    return c1 && c2 ? c1.ID === c2.ID : c1 === c2;
  }

  UserAppAccess:any[];
  CurrentAccess:any;

  GetUserAppAccess(){

    var request = {
      User:this.parent.User,
      Settings:this.parent.User.Settings,
      Language:this.parent.getLanguage(),
      UserID:this.parent.User.Id
    };

    this.parent.loading = true;

    this.service.GetUserAppAccess(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.UserAppAccess = response["UserAppAccess"];
        this.UserAppAccess = this.UserAppAccess.filter(x => x.Access == true);

        if(this.UserAppAccess.some(x => x.IsSelected == true)){
          this.CurrentAccess = this.UserAppAccess.filter(x => x.IsSelected == true)[0];
        }
      }
   
      this.parent.loading = false;
    });
  }

  UpdateUserLastSelectedApplication(AppAccess:any){

    var request = {
      User:this.parent.User,
      Settings:this.parent.User.Settings,
      Language:this.parent.getLanguage(),
      UserID:this.parent.User.Id,
      ApplicationID:AppAccess?.Application?.ID
    };

    this.parent.loading = true;

    this.service.UpdateUserLastSelectedApplication(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.GetUserAppAccess();
      }
   
      this.parent.loading = false;
    });
  }

}
